(function () {
  function initHappyYakSearch() {
    if (!window.jQuery) return;

    var $ = window.jQuery;
    var $inputs = $(".js-search-bar-input");

    if (!$inputs.length) return;

    $inputs.off("keyup keydown keypress input click");

    var requestNumber = 0;
    var timer;

    function score(product, query) {
      var title = (product.title || "").toLowerCase();
      var words = title.split(/[\s\-]+/);

      if (title === query) return 1000;
      if (title.indexOf(query) === 0) return 900;

      if (words.some(function (word) {
        return word.indexOf(query) === 0;
      })) return 800;

      if (title.indexOf(query) !== -1) return 500;

      return 0;
    }

    function render($results, products, query) {
      $results.empty();

      products = products
        .filter(function (product) {
          return score(product, query) > 0;
        })
        .sort(function (a, b) {
          return score(b, query) - score(a, query);
        })
        .slice(0, 5);

      if (!products.length) {
        $results.append(
          $('<div class="note"></div>').text("No results found")
        );
        $results.show();
        return;
      }

      products.forEach(function (product) {
        var $link = $("<a></a>").attr("href", product.url);

        var image = product.featured_image &&
          (product.featured_image.url || product.featured_image);

        var $image = $('<div class="img"></div>');

        if (image) {
          $image.append($("<img>").attr("src", image));
        }

        $link.append($image);
        $link.append(
          $('<div class="search-title"></div>').text(product.title)
        );

        if (product.price !== undefined && product.price !== null) {
          var price = String(product.price).trim();

          if (price && price.charAt(0) !== "$") {
            price = "$" + price;
          }

          $link.append(
            $('<div class="serach-price"><span class="money"></span></div>')
              .find(".money").text(price).end()
          );
        }

        $results.append($link);
      });

      var root = (window.Shopify && Shopify.routes &&
        Shopify.routes.root) || "/";

      $results.append(
        $('<a class="note"></a>')
          .attr("href", root + "search?type=product&q=" +
            encodeURIComponent(query))
          .text("See all results")
      );

      $results.show();
    }

    $inputs.on("focus input", function () {
      var $input = $(this);
      var query = $input.val().trim().toLowerCase();

      var $results = $input.closest(".js-search-bar-wrapper")
        .find(".js-search-result-bar");

      if (!$results.length) {
        $results = $(".js-search-result-bar").first();
      }

      clearTimeout(timer);
      var currentRequest = ++requestNumber;

      if (query.length < 2) {
        $results.empty().hide();
        return;
      }

      $(".js-menu-overlay, .top-search-close")
        .addClass("is_active");

      timer = setTimeout(function () {
        var root = (window.Shopify && Shopify.routes &&
          Shopify.routes.root) || "/";

        $.ajax({
          url: root + "search/suggest.json",
          data: {
            q: query,
            "resources[type]": "product",
            "resources[limit]": 10,
            "resources[options][unavailable_products]": "hide"
          },
          dataType: "json",
          success: function (data) {
            if (currentRequest !== requestNumber) return;

            var products = (
              data.resources &&
              data.resources.results &&
              data.resources.results.products
            ) || [];

            render($results, products, query);
          },
          error: function () {
            if (currentRequest !== requestNumber) return;
            $results.empty().hide();
          }
        });
      }, 180);
    });
  }

  if (document.readyState === "complete") {
    initHappyYakSearch();
  } else {
    window.addEventListener("load", initHappyYakSearch);
  }
})();